if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.isCarousel = this.classList.contains('product-media-modal--carousel');
      if (this.isCarousel) this.setupCarousel();
    }

    setupCarousel() {
      this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
        button.addEventListener('pointerup', (event) => event.stopPropagation());
        button.addEventListener('click', () => {
          this.navigate(button.classList.contains('product-media-modal__nav--next') ? 1 : -1);
        });
      });

      const content = this.querySelector('.product-media-modal__content');
      if (content) {
        content.addEventListener('pointerup', (event) => {
          if (event.target !== event.currentTarget) event.stopPropagation();
        });
      }

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ARROWRIGHT') this.navigate(1);
        if (event.code.toUpperCase() === 'ARROWLEFT') this.navigate(-1);
      });
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      if (this.isCarousel) this.preloadImages();
    }

    preloadImages() {
      if (this.imagesPreloaded) return;
      this.imagesPreloaded = true;
      // Hidden carousel slides never enter the viewport, so their lazy images
      // would only start downloading on navigation — force-fetch them now.
      this.querySelectorAll('.product-media-modal__content img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    }

    mediaItems() {
      // Hidden slides (e.g. other variants' images on the bed builder) are skipped by next/previous.
      return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]:not([hidden])'));
    }

    navigate(direction) {
      const items = this.mediaItems();
      if (items.length < 2) return;
      const activeIndex = items.findIndex((item) => item.classList.contains('active'));
      const nextItem = items[(activeIndex + direction + items.length) % items.length];
      this.setActiveMedia(nextItem);
    }

    setActiveMedia(activeMedia) {
      if (!activeMedia) return;
      this.querySelectorAll('[data-media-id]').forEach((element) => element.classList.remove('active'));
      window.pauseAllMedia();
      activeMedia.classList.add('active');
      this.loadActiveMedia(activeMedia);
    }

    loadActiveMedia(activeMedia) {
      if (activeMedia.nodeName != 'DEFERRED-MEDIA') return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      if (!activeMediaContent) return;
      if (activeMediaContent.querySelector('.js-youtube') || activeMediaContent.querySelector('.js-vimeo') || activeMediaContent.querySelector('video')) {
        if (activeMedia.getAttribute('loaded')) {
          activeMedia.playContent();
        } else {
          activeMedia.loadContent();
        }
      }
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      activeMedia.classList.add('active');
      if (this.isCarousel && activeMedia.tagName === 'IMG') activeMedia.setAttribute('fetchpriority', 'high');

      if (!this.isCarousel) {
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }

      this.loadActiveMedia(activeMedia);
    }
  });
}
